import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function DispensaryLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { loginSuccess } = useApp();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      loginSuccess(data);
      toast.success("Welcome back");
      navigate("/dispensary/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="eyebrow mb-2">Dispensary portal</div>
          <h1 className="font-serif text-4xl">Sign in</h1>
        </div>

        <form
          onSubmit={submit}
          className="bg-card border border-border rounded-2xl p-7 space-y-4"
        >
          <div>
            <Label className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Email
            </Label>
            <Input
              data-testid="login-email-input"
              type="email"
              value={form.email}
              onChange={(e) =>
                setForm((f) => ({ ...f, email: e.target.value }))
              }
              required
              className="h-11 mt-1.5"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Password
            </Label>
            <Input
              data-testid="login-password-input"
              type="password"
              value={form.password}
              onChange={(e) =>
                setForm((f) => ({ ...f, password: e.target.value }))
              }
              required
              className="h-11 mt-1.5"
            />
          </div>

          <Button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-primary text-primary-foreground hover:bg-primary/90"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
          <p className="text-center text-xs text-muted-foreground pt-2">
            New to Bud Link?{" "}
            <Link
              to="/dispensary/signup"
              data-testid="login-signup-link"
              className="text-foreground underline underline-offset-4"
            >
              Create an account
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}
